<template>
  <div class="relative flex my-2.5 mb-8 items-center">
    <div class="rounded-full cursor-pointer hover:bg-grey-light-200 p-2 transition-colors" @click="emit('back')">
      <ChevronLeft class="h-4 w-4" />
    </div>
    <div class="absolute inset-x-0 text-center text-lg font-semibold text-grey-light-900 pointer-events-none">
      Payment breakdown
    </div>
  </div>
  <div class="flex items-center justify-between mb-4">
    <div class="flex flex-col gap-1">
      <p class="text-grey-light-900 text-md font-medium">Payment Schedule</p>
      <p class="text-brand-600 text-sm">Breakdown of your payment plan.</p>
    </div>
    <Button @click="emit('toggle')" variant="ghost" size="sm" type="button">
      <ChevronDown class="transition-all" :class="{ 'rotate-180': show }" />
    </Button>
  </div>
</template>

<script setup lang="ts">
import { ChevronDown, ChevronLeft } from 'lucide-vue-next';
import { Button } from '../../../ui/button';

defineProps<{
  show: boolean;
}>();
const emit = defineEmits(['back', 'toggle']);
</script>
